import React, { useEffect, useRef, useState } from "react";
import CreativeList from "../components/CreativeList";
import CountCard from "../components/CountCard";
import { Card } from "react-bootstrap";
import { findIcon } from "../../../../dashboard/icons";
import VerticalTabs from "../components/VerticalTabs";
import HeatMapsChart from "../../../../../components/chart/HeatMapsChart";
import {
  GRAPH_FILL_COLOR,
  GRAPH_MINI_FILL_COLOR,
} from "../constant/graph-color-scheme";
import DonutChart from "../../../../../components/chart/DonutChart";
import LineChart from "../../../../../components/chart/LineChart";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import {
  useGetSummaryCamapgingAnalytics,
  useGetSummaryCreativeList,
  useGetSummaryDaywiseDistribution,
  useGetSummaryDeviceDistribution,
  useGetSummaryImpressionGraph,
  useGetSummaryCampaignGroupList,
  useGetSummaryGroupList,
  useGetLocationStateMap,
} from "../../../../../queries/query-hooks/workspace/brand-ads-hook";
import {
  formatLocalizedDate,
  formatNumberWithCommas,
  transformGraphData,
} from "../../../../../common/utils/utils";
import SquareChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/square-chart-skeleton";
import CountCardSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/count-card-skeleton";
import MapAnalyticsSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/map-analytics-skeleton";
import VerticalTabSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/vertical-tab-skeleton";
import VideoSwiperSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/video-swiper-skeleton";
import { useParams } from "react-router-dom";
import * as dayjs from "dayjs";
import { ProjectHeaderTopBar } from "@ui";
import ProjectFilters from "../components/ProjectFilters";
import IndiaMap from "components/chart/IndiaMap";
import { useDispatch, useSelector } from "react-redux";
import { selectProject } from "store/project/project.selector";
import { updateProject } from "store/project/project.action";

function Summary() {
  const { project_id } = useParams();
  const dispatch = useDispatch();
  const project = useSelector(selectProject);
  const chartRef = useRef(null);
  const [analysisType, setAnalysisType] = useState("week");
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);
  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [isProjectChange, setIsProjectChange] = useState(false);

  const specialityCount = projectDetails
    ?.at(0)
    ?.project_attributes?.find(
      (item) => item.attribute_name === "speciality_count"
    )?.attribute_value;

  useEffect(() => {
    setIsProjectChange(true);
  }, [project_id]);

  useEffect(() => {
    if (projectDetails && projectDetails?.length > 0) {
      const today = dayjs();
      const projectEndDate = dayjs(projectDetails[0]?.project_end_date);
      let result = projectDetails[0]?.project_end_date;

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        result = today.subtract(1, "day");
      } else {
        result = projectEndDate;
      }

      if (project?.start_date && project?.end_date && !isProjectChange) {
        setDateRangePayload({
          start_date: project?.start_date,
          end_date: project?.end_date,
        });
        dispatch(
          updateProject({
            start_date: project?.start_date,
            end_date: project?.end_date,
          })
        );
      } else {
        setDateRangePayload({
          start_date: formatLocalizedDate(
            new Date(projectDetails[0]?.project_start_date),
            "YYYY-MM-DD[T]00:00:00.000Z"
          ),
          end_date: formatLocalizedDate(
            new Date(result),
            "YYYY-MM-DD[T]23:59:59.000Z"
          ),
        });
        dispatch(
          updateProject({
            start_date: formatLocalizedDate(
              new Date(projectDetails[0]?.project_start_date),
              "YYYY-MM-DD[T]00:00:00.000Z"
            ),
            end_date: formatLocalizedDate(
              new Date(result),
              "YYYY-MM-DD[T]23:59:59.000Z"
            ),
          })
        );
        setIsProjectChange(false);
      }
    }
  }, [projectDetails, project_id]);

  function getGroupIdsCommaSeparated(data) {
    return data.map((item) => item.group_id).join(",");
  }

  const { data: campaignGroupList, isLoading: isCampaignGroupListLoading } =
    useGetSummaryCampaignGroupList(project_id, {
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    });

  const { data: campaignGroupWiseData, isLoading: isCampaignGroupWiseLoading } =
    useGetSummaryGroupList(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const [activeCampaignGroup, setActiveCampaignGroup] = useState({});

  useEffect(() => {
    if (
      campaignGroupList &&
      Array.isArray(campaignGroupList) &&
      campaignGroupList?.length > 0 &&
      !("id" in activeCampaignGroup)
    ) {
      setActiveCampaignGroup(campaignGroupList[0]);
    }
  }, [campaignGroupList]);

  const { data: camapignAnalyticsData, isLoading: isCamapignAnalyticsLoading } =
    useGetSummaryCamapgingAnalytics(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: creativeDataList, isLoading: isCreativeDataListLoading } =
    useGetSummaryCreativeList(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: impressionGraphData, isLoading: isImpressionGraphDataLoading } =
    useGetSummaryImpressionGraph(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      activeCampaignGroup?.id &&
        !!dateRangePayload.start_date &&
        !!dateRangePayload.end_date
        ? true
        : false
    );

  const { data: stateMapData, isLoading: isStateMapLoading } =
    useGetLocationStateMap(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
        type: "percentage",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const {
    data: deviceDistributionData,
    isLoading: isDeviceDistributionDataLoading,
  } = useGetSummaryDeviceDistribution(
    project_id,
    {
      start_date: dateRangePayload.start_date,
      end_date: dateRangePayload.end_date,
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    },
    !!dateRangePayload.start_date && !!dateRangePayload.end_date
  );

  const {
    data: daywiseDistributionData,
    isLoading: isDaywiseDistributionDataLoading,
  } = useGetSummaryDaywiseDistribution(
    project_id,
    {
      start_date: dateRangePayload.start_date,
      end_date: dateRangePayload.end_date,
      analysis_type: analysisType,
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    },
    !!dateRangePayload.start_date && !!dateRangePayload.end_date
  );

  const countCardData = [
    {
      text: "Impression Target",
      count: formatNumberWithCommas(camapignAnalyticsData?.target) || "0",
      icon: findIcon("ImpressionTarget", "dual-tone", 42),
      bgPrimary: true,
    },
    {
      text: "Impression Delivered",
      count:
        formatNumberWithCommas(camapignAnalyticsData?.impressions_count) || "0",
      icon: findIcon("ImpressionDelivered", "dual-tone", 42),
      bgPrimary: false,
    },
    {
      text: "Creatives",
      count: formatNumberWithCommas(camapignAnalyticsData?.creatives) || "0",
      icon: findIcon("ImpressionCreatives", "dual-tone", 42),
      bgPrimary: true,
    },
    {
      text: "Campaigns",
      count: projectDetails
        ? formatNumberWithCommas(projectDetails[0]?.project_group_data?.length)
        : "0",
      icon: findIcon("ImpressionCampaigns", "dual-tone", 42),
      bgPrimary: false,
    },
  ];

  const formatDaywiseReportData = (data) => {
    const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    const result = data.reduce((acc, { Day, label, Reach }) => {
      if (!acc[label]) {
        acc[label] = {
          name: analysisType === "week" ? `Week ${label}` : label,
          data: daysOfWeek.map((day) => ({ x: day || "", y: 0 })),
        };
      }

      const dayIndex = daysOfWeek.indexOf(Day);

      if (acc[label].data.length >= dayIndex && dayIndex >= 0) {
        acc[label].data[dayIndex].y = Reach;
      }
      return acc;
    }, {});

    return Object.values(result)
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true })
      )
      .map((week) => ({
        name: week.name,
        data: week.data,
      }));
  };
  const performanceDistribution = {
    series:
      daywiseDistributionData && daywiseDistributionData?.length > 0
        ? formatDaywiseReportData(daywiseDistributionData)
        : [],
    title: "Day Wise Performance Distribution",
  };

  const transformStateMapData = (data = [], key) => {
    return [
      data?.reduce((acc, item) => {
        if (item.name && item[key] !== null) {
          acc[item.name] = item[key];
        }
        return acc;
      }, {}),
    ];
  };

  const stateMapViewsData = transformStateMapData(
    stateMapData,
    "views_percent"
  );

  const deviceDistributionChartData = {
    series:
      deviceDistributionData?.length > 0
        ? transformGraphData(deviceDistributionData, "Device_count", "new_os")
            ?.series
        : [],
    title: "Device Distribution",
    labels:
      deviceDistributionData?.length > 0
        ? transformGraphData(deviceDistributionData, "Device_count", "new_os")
            ?.label
        : [],
  };

  const impressionChartOptions = {
    title: "Impression",
    labels:
      impressionGraphData && impressionGraphData?.length > 0
        ? transformGraphData(impressionGraphData, "VIEWS", "formatted_date")
            ?.label
        : [],
    series:
      impressionGraphData && impressionGraphData?.length > 0
        ? transformGraphData(impressionGraphData, "VIEWS", "formatted_date")
            ?.series
        : [],
  };

  function getWeeksBetween(startDate, endDate) {
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    if (!end.isAfter(start)) {
      return 0;
    }
    const diffInDays =
      end.diff(start, "day") + (start.day() === 0 ? 0 : 6 - start.day());
    return Math.floor(diffInDays / 7);
  }

  return (
    <div className="row">
      <div className="col-sm-12">
        <ProjectHeaderTopBar
          projectType="Brand Ads"
          title="Summary"
          projectStartDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_start_date
              : ""
          }
          projectEndDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_end_date
              : ""
          }
          isProjectDetailsLoading={isProjectDetailsLoading}
          rightComponent={
            <ProjectFilters
              title="Summary"
              dateLabel={dateRangePayload}
              setDateRangePayload={(e) => {
                setDateRangePayload(e);
                if (getWeeksBetween(e.start_date, e.end_date) > 16) {
                  setAnalysisType("month");
                } else {
                  setAnalysisType("week");
                }
              }}
              projectStartDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_start_date
                  : ""
              }
              projectEndDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_end_date
                  : ""
              }
              isProjectDetailsLoading={isProjectDetailsLoading}
            />
          }
        />
      </div>
      <div className="col-sm-12">
        <Card>
          <Card.Body>
            <div className="row mb-md-0 mb-lg-4">
              {!isCamapignAnalyticsLoading &&
              Object.values(camapignAnalyticsData)?.length > 0 ? (
                <>
                  {countCardData?.map((item, index) => {
                    return (
                      <div
                        key={`count-card-${index}`}
                        className="col-lg-3 col-md-6 col-sm-12 mb-4 mb-md-4 mb-lg-0"
                      >
                        <CountCard
                          containerClass="h-100"
                          key={index}
                          text={item.text}
                          count={item.count}
                          icon={item.icon}
                          onclickPath={item.onClickPath}
                          bgPrimary={item.bgPrimary}
                        />
                      </div>
                    );
                  })}
                </>
              ) : (
                <CountCardSkeleton />
              )}
            </div>
            {!isCampaignGroupWiseLoading &&
            campaignGroupWiseData?.length > 0 ? (
              <VerticalTabs
                orientation="horizontal"
                tabs={campaignGroupWiseData}
                specialityCount={specialityCount || 0}
              />
            ) : (
              <VerticalTabSkeleton />
            )}
          </Card.Body>
        </Card>
      </div>

      <div className="mb-4 col-sm-12">
        <LineChart
          chartRef={chartRef}
          labels={impressionChartOptions.labels}
          graphColor={GRAPH_FILL_COLOR}
          series={impressionChartOptions.series}
          seriesName="Impressions"
          sponsoredContentList={campaignGroupList}
          activeCampaignGroup={activeCampaignGroup}
          setActiveCampaignGroup={setActiveCampaignGroup}
          loading={isImpressionGraphDataLoading}
          chartTitle={"Impressions"}
          hasData={
            impressionChartOptions?.series &&
            Array.isArray(impressionChartOptions?.series) &&
            impressionChartOptions?.series?.length > 0
              ? true
              : false
          }
        />
      </div>

      <div className="mb-0 col-sm-12">
        {!isCreativeDataListLoading && creativeDataList?.length > 0 ? (
          <CreativeList data={creativeDataList} />
        ) : (
          <VideoSwiperSkeleton />
        )}
      </div>
      <div className="d-flex flex-column col-md-12 col-lg-6 pe-2 mb-4">
        {!isStateMapLoading && stateMapData?.length > 0 ? (
          <IndiaMap
            title={"Location"}
            stateData={stateMapViewsData}
            valueSuffix={"%"}
          />
        ) : isStateMapLoading ? (
          <MapAnalyticsSkeleton />
        ) : null}
      </div>
      <div className="col-md-12 col-lg-6 ">
        <div className="row">
          <div className="mb-4 col-sm-12">
            {!isDeviceDistributionDataLoading &&
            deviceDistributionData?.length > 0 ? (
              <DonutChart
                series={deviceDistributionChartData.series}
                title={deviceDistributionChartData.title}
                labels={deviceDistributionChartData.labels}
                graphColor={GRAPH_MINI_FILL_COLOR}
                height={320}
              />
            ) : isDeviceDistributionDataLoading ? (
              <SquareChartSkeleton />
            ) : null}
          </div>
          <div className="mb-4 col-sm-12">
            {!isDaywiseDistributionDataLoading &&
            daywiseDistributionData?.length > 0 ? (
              <HeatMapsChart
                series={performanceDistribution.series}
                title={performanceDistribution.title}
              />
            ) : isDaywiseDistributionDataLoading ? (
              <SquareChartSkeleton />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Summary;
